import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort,  } from '../../../shared/utility';
import { apcologo, lightningHandLogo, shamalAzzourLogo, ministryLogo, newKuwaitLogo, boldArabicFont, securityStamp, securityPositionFalah, securitySignatureFalah, securityPositionAnezi, securitySignatureAnezi, securityPositionJaseer, securitySignatureJaseer } from '../../../shared/fontsAndBitImages';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG, EMPLOYEE_LOAN_ID } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import AZNLogo from '../../../assets/images/AZN LOGO .jpg';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';


const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        dateFormat={field.dateFormat}
        view={field.view}
        metaData={Object.assign({}, metaData, { "TA Request Number": props.TARequestNumber })}
    /> || null;

};

const currencyList = [
    {"label":"INR","value":"INR","id":"INR"},
    {"label":"KWD","value":"KWD","id":"KWD"},
    {"label":"SAR","value":"SAR","id":"SAR"},
    {"label":"USD","value":"USD","id":"USD"},
    { "label": "AED", "value": "AED", "id": "AED" },
    {"label":"EUR","value":"EUR","id":"EUR"},
    {"label":"OMR","value":"OMR","id":"OMR"},
    {"label":"BHD","value":"BHD","id":"BHD"},
    {"label":"GBP","value":"GBP","id":"GBP"},
    {"label":"CAD","value":"CAD","id":"CAD"},
    {"label":"CHF","value":"CHF","id":"CHF"},
    {"label":"DZD","value":"DZD","id":"DZD"},
    { "label": "IQD", "value": "IQD", "id": "IQD" },
    {"label":"JOD","value":"JOD","id":"JOD"},
    {"label":"PKR","value":"PKR","id":"PKR"},
    {"label":"PHP","value":"PHP","id":"PHP"},   
    { "label": "JPY", "value": "JPY", "id": "JPY" }]; 

class AddEmployeeLoan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:'',
            month:'',
            year:'',
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            payslipGenerated: false,
            stageSequence: 0,
            month: false,
            year: false,
            requestDate: moment(),
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments:[],
        }
        this.handleContainer = this.handleContainer.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => {
            // First pass: update the changed field
            let updatedStageField = stage.stage_Field.map(field => 
                Object.assign({}, { ...field }, { fieldValue: field.fieldName === name ? value : field.fieldValue })
            );
            
            // Second pass: check if we need to recalculate Installment Amount
            const changedField = updatedStageField.find(f => f.fieldName === name);
            
            if (changedField && (changedField.fieldDescription === 'Requested Amount' || changedField.fieldDescription === 'Number Of Installments')) {
                // Find all the fields we need
                const requestedAmountField = updatedStageField.find(f => f.fieldDescription === 'Requested Amount');
                const numberOfInstallmentsField = updatedStageField.find(f => f.fieldDescription === 'Number Of Installments');
                const installmentAmountField = updatedStageField.find(f => f.fieldDescription === 'Installment Amount');
                
                // Calculate if all fields exist and have valid values
                if (installmentAmountField && requestedAmountField && numberOfInstallmentsField) {
                    const requestedAmount = requestedAmountField.fieldValue;
                    const numberOfInstallments = numberOfInstallmentsField.fieldValue;
                    
                    if (requestedAmount && numberOfInstallments && numberOfInstallments != 0) {
                        const installmentAmount = (parseFloat(requestedAmount) / parseFloat(numberOfInstallments)).toFixed(2);
                        
                        // Update the installment amount field
                        updatedStageField = updatedStageField.map(field =>
                            field.fieldDescription === 'Installment Amount' ? 
                                Object.assign({}, { ...field }, { fieldValue: installmentAmount }) : 
                                field
                        );
                    }
                }
            }
            
            return Object.assign({}, { ...stage }, { stage_Field: updatedStageField });
        });

        this.setState({
            process: updatedProcess,
            payslipGenerated: false
        });
    }

    rowExpansionTemplate = (data) => {
        try
        {
        // let currency = currencyList.find(el => el.value == data.Original_Currency);
        // let currencyId = currency && currency.id || '';
        //     let currencyLabel = currency && currency.label || '';
        //    // let fml = dependantdata.find(ef => ef.value == data.familyMembers);

        
        return (
            <div className="p-grid p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                <div className="p-col-12 p-md-12">
                    <div className="p-grid">

                        <div className="p-md-3">Date Of Expenditure: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expenditure_Date}</div>

                        {/* <div className="p-md-3">Family Members: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Description}</div> */}
                        {data.Family_Members && 
                        <><div className="p-md-3">Family Members: </div><div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Family_Members}</div></>
                        }

{/*                         <div className="p-md-3">Expense Sub Category:</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expense_Nature}</div>

                        <div className="p-md-3">Amount In Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Hotel_Expense + ' ' + currencyId}</div>

                        <div className="p-md-3">Exchange Rate: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Transportation_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Amount(KWD)</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Meals_Expense  + ' ' + currencyId}</div> */}

                        {/* <div className="p-md-3">Expense Sub Category:</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expense_Sub_Category}</div>

                        <div className="p-md-3">Amount In Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Amount_in_Original_Currency + ' ' + currencyLabel}</div> */}

                        {/* <div className="p-md-3">Exchange Rate: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Exchange_Rate  + ' ' + currencyId}</div> */}

{/*                         <div className="p-md-3">Amount(KWD)</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Meals_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Purchases Expense </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Purchases_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Other Expenses </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Other_Expenses  + ' ' + currencyId}</div>

                        <div className="p-md-3">Total Expenses: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Total_Expenses  + ' ' + currencyId}</div>

                        <div className="p-md-3">Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{currencyLabel || data.Original_Currency || ''}</div> */}

                        <div className="p-md-3">Exchange Rate:  </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Exchange_Rate}</div>

                        <div className="p-md-3">Amount In KWD:  </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Amount_in_KWD}</div>
                    </div>
                </div>
            </div>
            
            );
        }
        catch (error) {
            this.setState({error : error})
         }  
    }

    setFieldValueUsingFieldId(inputFieldId, process, valueToBeSet) {
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldId ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet,childRowNmbr) {
        
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr  ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    handleContainer = (field) => {
        try {
        this.setState({ loading: true,ifaddupdatepressed: 1 });
        const { process, stageSequence } = this.state;
        const { location } = this.props;
        let cldr = field.childRowNmbr;
        let flag = 0;
            let vcategory = '';

            let kwdtotalAmount = parseFloat(0.000).toFixed(3);
    
            let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                return el.stage_Field.map((el) => {
                    if (el.fieldDescription === 'Description' && (el.fieldValue === "0" || el.fieldValue === "")) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'please enter description' });
                        flag = 1;
                        return;
                    }
                    if (el.fieldDescription === 'Category') {
                        vcategory = el.fieldValue;
                        
                    }
                    if (el.fieldDescription === 'Family Members' && el.fieldValue === null && (vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F14BA' || vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F13BA')) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Family Member' });
                        flag = 1;
                        return;
                    }
                    return (el.fieldDescription === 'Amount in KWD') && el || null;
                }).filter(el => el != null).map(el => Object.assign({}, {
                    amount: parseFloat( el.fieldValue)
                }));
            });

            if (flag === 1) return;

            let totalAmount = parseFloat(0.000);
            let j;
            for (j = 0; j < dummy[0].length; j++) {
                totalAmount += parseFloat(dummy[0][j].amount)
            }

            let error = 0;
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                if (stageIndex === 0) {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || [];
                    const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                    if (fields && fields.length > 0) {
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        const newFields = fields.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            a.push(Object.assign({}, { ...el }, {
                                fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: (el.fieldType == 1) ? ((field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount : (el.fieldDescription == 'Hotel Expense') ? 0 :
                                    (el.fieldDescription == 'Transportation Expense') ? 0 : (el.fieldDescription == 'Meals Expense') ? 0 : (el.fieldDescription == 'Purchases Expense') ? 0 : (el.fieldDescription == 'Other Expenses') ? 0 : '') : (el.fieldDescription == 'Exchange Rate') ? 0 : null
                            }));
                            return a;
                        }, []);
                        return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                    } else if (location && location.state && location.state.stagesequence === stageIndex) {
                        error = 1;
                        return stage;
                    }
                    else {
                        return stage;
                    }
                } else {
                    return stage;
                }
            });
            j = 0;
        
           //  const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldId("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount)

            const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldidrownum("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount, cldr)




            setTimeout(() => {
                try
                {

                    if (error) {
                        this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
                        return;
                    }
                  
                     this.setState({ loading: false, process: initialValuesWithUpdatedTotal });
                   
                    //this.setState({ loading: false });
                //this.setState({ loading: false, process: InitialValues });
                //this.setState({ loading: false }, { process: process });

                }

                catch (error)
                {
                    //handleExpectedError(error);
                    this.setState({ error: error });
                } 
            
            }, 3000);

        }

        catch (error)
        {
            //handleExpectedError(error);
            this.setState({ error: error });
        }
       
        //i = 0;

        // this.setState({
        //     process: this.state.process.filter((p,i) => i <= 20  ).map(stage => Object.assign({}, { ...stage }, {
        //         stage_Field: stage
        //             .stage_Field.map(field => {
        //                 return Object.assign({}, { ...field }, { fieldValue:  field.fieldDescription === 'Total Amount in KWD' && totalAmount ? totalAmount  : field.fieldValue })
        //             })
        //     }))
        // });

   
        // this.setState({
        //     process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))
        // });
    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {}} = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;         
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }


    generatePayslip = (type) => {
        let process= this.state.process;
        const { containerData, location = {},} = this.props;
        const { state = {} } = location;
        let requestId = state.requestId
        this.setState({ loading: true });

        axios.get('/master/api/Employee/GetFinalapprover?RequestId='+requestId)
        .then((response) => {
            if(response.status === 200){
                let empId = response.data.toUpperCase();
                this.handlePayslipInPdf(type, empId);
            }
        }).catch((error) => {
            this.growl.show({ severity: 'error', summary: null, detail: 'Final Approver API Error, please try again' });
            this.setState({ loading: false });
        })

    }


        handlePayslipInPdf = (type) =>{

            const process = this.state.process;
            const stage_Field = process[0].stage_Field; 
            
            const requestDate = stage_Field.find(
                field => field.fieldId === "bd8d8b85-ff8c-467c-8784-786ec581706f" 
                );
            
            const reqFor = stage_Field.find(
                field => field.fieldId === "ecbe4f9a-db91-4c42-a11e-63e5eb0cdae8" 
                );
            
            let requestedFor =   '';
            let propsreqFor = this.props.EmployeeList;

            if (propsreqFor[0].value === reqFor.fieldValue) {
                requestedFor = propsreqFor[0].label;
                 };
           
            const position =  this.props.loggedUserDetail.jobTitle
            const department =  this.props.loggedUserDetail.dept  

            const sapno = stage_Field.find(
                field => field.fieldId === "33739bf0-d3e0-4776-99e4-139432f23a8b"
            )   
            
            const comment = stage_Field.find(
                field => field.fieldId === "33739bf0-d3e0-4776-99e4-139442f22a8b"
            ) 

            const notes = stage_Field.find(
                field => field.fieldId === "33739bf0-d3e0-4776-99e4-139432f22a8b"
            ) 

            const visitorDetailsHeader = stage_Field.find(
                field => field.fieldDescription === "Visitor Details" && field.parentFieldId === "000"
                );

            const generalInfoHeader = stage_Field.find(
                field => field.fieldDescription === "General Information" && field.parentFieldId === "000"
                );    
            
            const visitLocationHeader = stage_Field.find(
                field => field.fieldDescription === "Visting Location" && field.parentFieldId === "000"
                );   

            const vehicleDetailsHeader = stage_Field.find(
            field => field.fieldDescription === "Vehicle Details : " && field.parentFieldId === "000"
            );

            let visitorDetails = {};
            // If the header is found, gather its fields
            if (visitorDetailsHeader) {
                const visitorDetailsFields = stage_Field.filter(
                    field => field.parentFieldId === visitorDetailsHeader.fieldName
                );
            
               
                visitorDetailsFields.forEach(field => {
                    const rowNumber = field.childRowNmbr;
            
                  
                    if (!visitorDetails[rowNumber]) {
                        visitorDetails[rowNumber] = {};
                    }
            
                
                    const key = field.fieldDescription
                    .replace(/[^a-zA-Z0-9 ]/g, '') 
                    .replace(/\s+/g, '_') 
                    .toLowerCase();
                    visitorDetails[rowNumber][key] = field.fieldValue;
                });

                const maxRowNumber = Math.max(...Object.keys(visitorDetails).map(Number)); // Find the highest row number
                delete visitorDetails[maxRowNumber];
            }

            let generalinformation = {};
            // If the header is found, gather its fields
            if (generalInfoHeader) {
                const generalInfoFields = stage_Field.filter(
                    field => field.parentFieldId === generalInfoHeader.fieldName
                );
            
                // Group fields by childRowNmbr
                generalInfoFields.forEach(field => {
                    const rowNumber = field.childRowNmbr;
            
                    // Ensure the row exists in generalinformation
                    if (!generalinformation[rowNumber]) {
                        generalinformation[rowNumber] = {};
                    }
            
                    // Use fieldDescription as the key and fieldValue as the value
                    const key = field.fieldDescription
                    .replace(/[^a-zA-Z0-9 ]/g, '') // Remove special characters (e.g., #, \t, etc.)
                    .replace(/\s+/g, '_')          // Replace spaces with underscores
                    .toLowerCase(); // Convert description to a valid key
                    generalinformation[rowNumber][key] = field.fieldValue;
                });

                const maxRowNumber = Math.max(...Object.keys(generalinformation).map(Number)); // Find the highest row number
                delete generalinformation[maxRowNumber];
            }
            

            let visitlocation = {};
            // If the header is found, gather its fields
            if (visitLocationHeader) {
                const visitLocationFields = stage_Field.filter(
                    field => field.parentFieldId === visitLocationHeader.fieldName
                );
            
                // Group fields by childRowNmbr
                visitLocationFields.forEach(field => {
                    const rowNumber = field.childRowNmbr;
            
                    // Ensure the row exists in generalinformation
                    if (!visitlocation[rowNumber]) {
                        visitlocation[rowNumber] = {};
                    }
            
                    // Use fieldDescription as the key and fieldValue as the value
                    const key = field.fieldDescription
                    .replace(/[^a-zA-Z0-9 ]/g, '') // Remove special characters (e.g., #, \t, etc.)
                    .replace(/\s+/g, '_')          // Replace spaces with underscores
                    .toLowerCase(); // Convert description to a valid key
                    visitlocation[rowNumber][key] = field.fieldValue;
                });

                const maxRowNumber = Math.max(...Object.keys(visitlocation).map(Number)); // Find the highest row number
                delete visitlocation[maxRowNumber];
            }


            let vehicleDetails = {};
            // If the header is found, gather its fields
            if (vehicleDetailsHeader) {
                const vehicleDetailsFields = stage_Field.filter(
                    field => field.parentFieldId === vehicleDetailsHeader.fieldName
                );
            
               
                vehicleDetailsFields.forEach(field => {
                    const rowNumber = field.childRowNmbr;
            
                  
                    if (!vehicleDetails[rowNumber]) {
                        vehicleDetails[rowNumber] = {};
                    }
            
                
                    const key = field.fieldDescription
                    .replace(/[^a-zA-Z0-9 ]/g, '') 
                    .replace(/\s+/g, '_') 
                    .toLowerCase();
                    vehicleDetails[rowNumber][key] = field.fieldValue;
                });

                const maxRowNumber = Math.max(...Object.keys(vehicleDetails).map(Number)); // Find the highest row number
                delete vehicleDetails[maxRowNumber];
            }

                
                let ECHDR = [];
                let ECrequesterdata = [];
                let ECLine = [];
                let ECApproval = [];
                let workpermitStatusRei = [];
                let workpermitStatusSur = [];

               
    
                let VisitorDetailsHeader = [];
                let VisitorDetailsBody = [];
                let VisitorDetailsData = [];   
                
                let VehicleDetailsHeader = [];
                let VehicleDetailsBody = [];
                let VehicleDetailsData = [];   
                
                
                let ProjectDetailsHeader = [];
                let ProjectDetailsBody = [];
                let ProjectDetailsData = [];

                let VisitLocationHeader =[];
                let VisitLocationBody = [];
                let VisitLocationData = [];

                let ECitem= 'none';
                let firstPageWcditem = [];
    
                    if(ECLine.length > 0){
                        ECitem = 'multiple';
                        firstPageWcditem = ECLine[0];
                    } else {
                        ECitem = 'single';
                        firstPageWcditem = ECLine[0];
                    }
            
    
                let ECnumber ='N/A';       
                    this.setState({ECnumber:ECnumber});
               

           
                        
    
               
                VisitorDetailsHeader = [
                        [{
                        content: 'Visitor Name',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Iqama/Saudi ID',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'ID Expiry',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Nationality',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }}, 
                        {
                        content: 'Position',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }}, 
                        {
                        content: 'Company Name',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }}, 
                        ]
                    ];
                    const visitorDetailsArray = Object.values(visitorDetails); 
                    VisitorDetailsBody = visitorDetailsArray.map((el, index) => {
                        return[
                            //    {
                            //    content: index + 1,
                            //    styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            //    }},
                                {
                                content: el.visitor_name || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.iqama_saudi_id || '' ,
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: moment(el.id_expiry).format('DD/MM/YYYY') || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.nationality || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content:  el.position || '' ,
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.company_name || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                
                            ]
                        
                    })
                   
                    VisitorDetailsData =VisitorDetailsHeader.concat(VisitorDetailsBody);
               
    
                    VehicleDetailsHeader = [
                        [{
                        content: 'Vehicle No',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Vehicle Model',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Vehicle Color',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                         ]
                    ];

                    const vehicleDetailsArray = Object.values(vehicleDetails); 
                    VehicleDetailsBody = vehicleDetailsArray.map((el, index) => {
                        return[
                                {
                                content: el.vehicle_no || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.vehicle_model || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.vehicle_color || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                               
                            ]
                        
                    })
                   
                    VehicleDetailsData =VehicleDetailsHeader.concat(VehicleDetailsBody);
                    
                    ProjectDetailsHeader = [
                        [{
                        content: 'Name Of Project',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: '# of Project',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Department',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                         ]
                    ];
                    const generalinformationArray = Object.values(generalinformation); 

                    ProjectDetailsBody = generalinformationArray.map((el, index) => {
                        return[
                                {
                                content: el.name_of_project || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.project_no || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.department_ || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                               
                            ]
                        
                    })
                  
                    ProjectDetailsData =ProjectDetailsHeader.concat(ProjectDetailsBody);
    
                    VisitLocationHeader = [
                        [
                        {
                        content: 'Sites',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},    
                            
                        {
                        content: 'Area To Be Visited',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Time Of Visit',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                        {
                        content: 'Visit Duration',
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        }},
                         ]
                    ];
                    const visitlocationArray = Object.values(visitlocation);
                    VisitLocationBody = visitlocationArray.map((el, index) => {
                        
                        return[
                               {
                                content: el.site || '' ,
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.area_to_be_visited || '' ,
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.time_of_visit || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                                {
                                content: el.duration || '',
                                styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                                }},
                               
                            ]
                        
                    })
                  
                    VisitLocationData =VisitLocationHeader.concat(VisitLocationBody);
                
    
                // pdf generation starts
                var doc = new jsPDF('p', 'mm', 'a4', 3);//jsPDF(orientation, unit, format)
                let text = '';
                doc.setFontStyle('normal');
                doc.setFont("Courier");  
                doc.setFontSize(10);
            
                doc.autoTable({
                    theme: 'plain', // No grid or border
                    didDrawCell: function (data) {
                        if (data.column.index === 0 && data.cell.section === 'body') {
                            // Adjust logo position and size
                            doc.addImage(apcologo, 'PNG', data.cell.x , data.cell.y -3, 40, 20); // Increase size: width=40, height=20
                        }
                    },
                    startY: 9,
                    margin: {
                        left: 8.5
                    },
                    columnStyles: {
                        0: { cellWidth: 50 }, // Adjust logo column width
                        1: { cellWidth: 200 } // Adjust text column width to shift text
                    },
                    body: [
                        [
                            {
                                content: "", // Empty cell for logo
                                styles: { cellPadding: 0, borderColor: 'white' }
                            },
                            {
                                content: "ARABIAN PIPECOATING COMPANY", // Header text
                                styles: {
                                    halign: 'left',
                                    valign: 'middle',
                                    fontStyle: 'bold',
                                    fontSize: 14,
                                    textColor: 'black',
                                    cellPadding: { top: 5, left: 6, right: 0 }, // Add padding to move text right
                                    borderColor: 'white'
                                }
                            }
                        ]
                    ]
                });
                
                doc.setDrawColor(0, 0, 0); // Set border color to black
                doc.setLineWidth(0.5);
                doc.rect(160, 3, 40, 25); // Move box further up by setting y to 3

                // Add text inside the box
                doc.setFont('Helvetica', 'bold');
                doc.setFontSize(10);
                doc.text("Form No: __________", 163, 9); // Adjusted y position for Form No
                doc.text("Sec-001", 163, 16); // Adjusted y position for Section
                doc.text("Date: ____________", 163, 23); // Adjusted y position for Date

                
                let previousTableEnding = doc.lastAutoTable.finalY;
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 10,
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    lineWidth: 5,
                    body: [
                        [
                            {
                            content: "Visitor Permission Request Form",
                            styles: { halign: 'center', valign:'top', textColor: 'black',fillColor: 'rgb(228, 245, 255)', fontStyle: 'bold', fontSize: 17, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
    
                        ]
                    ]
    
                });  
    
                previousTableEnding = doc.lastAutoTable.finalY;

                doc.autoTable({
                    theme: 'plain', // No table borders or grid
                    startY: previousTableEnding + 10, // Start position for "Date: __________"
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    body: [
                        [
                            {
                                content: `Date: ${moment(requestDate.fieldValue).format('DD/MM/YYYY')}`,
                                styles: { halign: 'left', valign: 'middle', fontSize: 12, font: 'calibri', textColor: 'black' }
                            },
                        ]
                    ],
                    didDrawCell: (data) => {
                        // Remove cell border or additional box drawing
                        if (data.section === 'body') {
                            data.cell.styles.fillColor = null; // Remove background fill
                        }
                    }
                });
                
    
                previousTableEnding = doc.lastAutoTable.finalY;
               
                
 
                // work permit generation ending
    
                //safety catalog table generation started
                let pageNumber1 = doc.internal.getCurrentPageInfo().pageNumber;// test to print safety catalog on next page to avoid overlapping 
    
                // doc.autoTable({
                //     theme: 'grid',
                //     startY: previousTableEnding + 7,
                //     styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [252, 245, 255]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                //     margin: {
                //         left: 5
                //     },
                //     tableWidth: 200,
                //     body: VisitorDetailsData,
    
                // });
        

                // Add the heading
               
                doc.setFontSize(12); // Set font size for heading
                doc.text('Visitor Details:', 5, previousTableEnding + 10); // Add the heading text

                // Draw the table below the heading
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 13, // Position the table below the heading
                    styles: {
                        halign: 'center' // Center-align text in cells
                    },
                    headStyles: {
                        fillColor: [124, 95, 240] // Purple header background
                    },
                    alternateRowStyles: {
                        fillColor: [252, 245, 255] // Light purple for alternate rows
                    },
                    tableLineColor: [124, 95, 240], // Purple table border
                    tableLineWidth: 0.1, // Border thickness
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    body: VisitorDetailsData, // Table data
                });

                
                previousTableEnding = doc.lastAutoTable.finalY;
                
                doc.setFontSize(12); // Set font size for heading
                doc.text('General Informations:', 5, previousTableEnding + 10);

                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 13,
                    styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [252, 245, 255]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    body: ProjectDetailsData,
    
                }); 
    
                previousTableEnding = doc.lastAutoTable.finalY;

                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 7,
                    styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [252, 245, 255]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    body: VisitLocationData,
    
                }); 
                
                previousTableEnding = doc.lastAutoTable.finalY;
                
                doc.setFontSize(12); // Set font size for heading
                doc.text('Vehicle Details:', 5, previousTableEnding + 10);
     
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 13,
                    styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [252, 245, 255]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    body: VehicleDetailsData,
    
                }); 

                previousTableEnding = doc.lastAutoTable.finalY;
    
                // work permit generation ending
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 5,
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    lineWidth: 2,
                    body: [
                        [
                            {
                            content: "Notes: " + notes.fieldValue,
                            styles: { halign: 'left', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
    
                        ]
                    ]
    
                });  
               

                previousTableEnding = doc.lastAutoTable.finalY;
               
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 5,
                         margin: {
                        left: 5,
                        right: 35
                    },
                    tableWidth: 200,
                    columnStyles: { 0: { cellWidth: 55, }},
                    lineWidth: 35,
                    body: [
                            [
                            {
                                content: "Requester Name: ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                                }},
                            {
                                content: "SAP # ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }}, 
    
    
                            {
                                content: "Position ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                                }
                            },  
                            {
                                content: "Department ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                                }
                            },
                            {
                                content: "Signature ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                                }
                            },  
      
                        ], 
                        
                        [
                            {
                            content:  requestedFor + "\n" ,
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
                            {
                                content: sapno.fieldValue + "\n" ,
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }}, 
    
    
                        {
                            content: position + "\n" ,
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        },  
                        {
                            content:  department + "\n" ,
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        }, 
                        {
                            content:"\n" ,
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        }, 
    
                        ], 
    
    
                            
                    ]
                    
                }); 
                
                previousTableEnding = doc.lastAutoTable.finalY;
    
               
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 5,
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    lineWidth: 2,
                    body: [
                        [
                            {
                            content: "Comments: " + comment.fieldValue,
                            styles: { halign: 'left', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
    
                        ]
                    ]
    
                });
                

                previousTableEnding = doc.lastAutoTable.finalY;


                doc.autoTable({
                    theme: 'plain', // No borders or grid
                    startY: previousTableEnding + 10, // Position below the previous table
                    margin: {
                        left: 5
                    },
                    tableWidth: 200,
                    body: [
                        [
                            {
                                content: "______________\nSecurity Supervisor", // Signature line and title
                                styles: { halign: 'center', valign: 'middle', fontSize: 12, font: 'calibri', textColor: 'black', cellPadding: 5 }
                            },
                            {
                                content: "______________\nDepartment Manager", // Signature line and title
                                styles: { halign: 'center', valign: 'middle', fontSize: 12, font: 'calibri', textColor: 'black', cellPadding: 5 }
                            },
                        ]
                    ],
                    didDrawCell: (data) => {
                        // Remove any cell background or borders
                        if (data.section === 'body') {
                            data.cell.styles.fillColor = null; // No background
                        }
                    }
                });
 

                // Hardcoded table section from the uploaded image, adjusted
                doc.setFont('Helvetica', 'bold');
                doc.setFontSize(10);

                // Row 1
                doc.text("DRAWN BY: ", 10, 270); // Moved up
                doc.text("VK", 40, 270);
                doc.text("FORM REV'S ", 80, 270); // Made "FORM REV'S" column bigger
                doc.text("BY", 115, 270); // Reduced "BY" column size
                doc.text("DATE", 145, 270); // Reduced "DATE" column size

                // Row 2
                doc.text("CHECKED BY: ", 10, 275); // Moved up
                doc.text("AS", 40, 275);

                // Row 3
                doc.text("APPROVED BY: ", 10, 280); // Moved up
                doc.text("OM", 40, 280);

                // Row 4
                doc.text("DATE: ", 10, 285); // Moved up
                doc.text("1/12/2014", 40, 285);

                // Adding "HR Manager" to the new column
                doc.text("HR MANAGER", 172, 285);

                // Drawing horizontal lines for the table
                doc.setLineWidth(0.5);
                doc.line(8, 266, 200, 266); // Top border (moved up)
                doc.line(8, 287, 200, 287); // Bottom border (moved up)
                doc.line(8, 272, 200, 272); // Between first and second row
                doc.line(8, 277, 200, 277); // Between second and third row
                doc.line(8, 282, 200, 282); // Between third and fourth row

                // Drawing vertical lines for the table
                doc.line(8, 266, 8, 287);   // Left border
                doc.line(70, 266, 70, 287); // After "DRAWN BY" column
                doc.line(105, 266, 105, 287); // After "FORM REV'S" column
                doc.line(135, 266, 135, 287); // After "BY" column (smaller)
                doc.line(165, 266, 165, 287); // After "DATE" column (smaller)
                doc.line(200, 266, 200, 287); // Right border




                // previousTableEnding = doc.lastAutoTable.finalY;

                // doc.autoTable({
                //     theme: 'grid',
                //     styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [231, 215, 252]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                //     startY: 270,
                //     margin: {
                //         left: 5
                //     },
                //     tableWidth: 200,
                //     body: [
                //         [
                //             {
                //             content: "This is system Generated Expence Claim Document. No Signature Required",
                //             styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                //             }},
                            
                //         ],
                        
    
                //     ]
    
                // });             
    
               
    
    
    
                if(type === 'print'){
                    doc.autoPrint()
                    window.open(doc.output('bloburl'), ECnumber)
                    this.setState({ loading: false });
                    // resolve("Promise Resolved");
                } else if(type === 'view'){
                    window.open(doc.output('bloburl'), ECnumber)
                    this.setState({ loading: false });
                    // resolve("Promise Resolved");
                } else if (type === 'download'){
                    doc.save(this.props.location.state.requestNum);
                    this.setState({ loading: false });
                    // resolve("Promise Resolved");
                } else if(type === 'upload'){ 
                    let pdf = btoa(doc.output());
                    let FileName = "VisitorPass";
                    let Folder = 'VisitorPass';
                    let Attachment = pdf;
                    let MailData = {
                        FileName,
                        Folder,
                        Attachment
                    }
        
                    let dd = JSON.stringify(MailData);
                    let  generatedPdf = {Key : dd};
                    JSON.stringify(generatedPdf);    
                    return generatedPdf;            
                }
          
       
        }
    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;
        let requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        let loggedUserEmpId = this.props.loggedUserDetail.empID;


        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

        //         if (el.fieldDescription === 'Comment' && stageIndex === 0) {
        //             Comment = el.fieldValue;
        //         }
        //         if(el.fieldDescription === 'Expense Type' && stageIndex === 0){
        //             RequestType = el.fieldValue;
        //         }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });

        // if(!RequestType){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Expense Type before Submitting/Saving' });
        //     return;
        // }

        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Employee Loan Request',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: EMPLOYEE_LOAN_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'ELOAN';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'ELOAN';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'ELOAN';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'ELOAN';
            }


            if (type === 'edit' && this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            // if(requestNumber && submitType == 'submit'){//checking whether the request is in the requester stage or approver stage
            //     let generatedPdf = this.handlePayslipInPdf('upload', loggedUserEmpId.toUpperCase());
            //     axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            //         .then(response => {
            //             if(response.status == 200){
            //                 axios.post(url, JSON.stringify(datas))// triggering the submit/save of a request
            //                     .then(response => {
            //                         this.setState({ loading: false });
            //                         if (submitType === 'submit' || submitType === 'return') {
            //                             if (response.status === 200) {
            //                                 if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
            //                                     let submitValue = response.data.result && JSON.parse(response.data.result);
            //                                     let tableValue = [];
            //                                     if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
            //                                         tableValue = submitValue.Table.map(list => {
            //                                             return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
            //                                         })
            //                                     }
            //                                     if(submitType === 'submit'){
            //                                         this.setState({dialogBoxText: "Select Supervisor"})
            //                                     }
            //                                     if(submitType === 'return'){
            //                                         this.setState({dialogBoxText: "Return To", popupType:'return'})
            //                                     }
            //                                     this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
            //                                 } else {
            //                                     this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request submitted successfully' });
            //                                     this.props.history.push('/dashboard');
            //                                 }
            //                             } else {
            //                                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                             }

            //                         } else {
            //                             this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request saved successfully' });
            //                             this.props.history.push('/dashboard');
            //                         }

            //                     })
            //                     .catch(err => {
            //                         this.setState({ loading: false })
            //                         this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                     })
            //             }
    
            //         }).catch(err => {
            //             this.growl.show({ severity: 'error', summary: null, detail: 'File Upload API Failed. Please Approve again' });
            //             this.setState({ loading: false });
            //         })
            // } else 
                {
                axios.post(url, JSON.stringify(datas))
                .then(response => {

                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Employee Loan Request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Employee Loan Request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                })
            }

        }

    }

    componentDidMount() {
        const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        // getContainerData("B1F0B0EC-DF1D-414B-BD09-9AED7F0BA1BB");//Get Container Data
        if (type === 'add') {
        getContainerData("F7405B60-9933-4B08-A8BE-107AA21A05F7");//Get Container Data
        }
        getKeywordValues('Employee');//Get Employee Dropdown list
        getMasterKeywordList('Employee');//Get Employee
        getMasterKeywordList('nationality');//Get Nationality Dropdown list 
        getMasterKeywordList('OrgUnit');
        getMasterKeywordList('LOANTYPE');//Get Loan Type Dropdown list
        getMasterKeywordList('salarytypen');//Get Deduction Frequency Dropdown list
        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);

    }


    render() {
        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;
        const actionRowStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' };

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;  
        const dialogDynamicFooter = (
            <div style={actionRowStyle}>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary" />
            </div>
        );
        let a;
        {
            a = process.filter((p, i) => i <= parseInt(stageSequence));
       }


        return (
            
            <div className="p-grid leaverequest">
                           {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                           {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                           <Toast ref={(el) => this.growl = el} />
                           <div className="p-col-12">
                               <div className="card card-w-title" style={{ position: 'relative' }}>
                                   <h1>
                                   Loan Request
                                       <Link to={'/Employeeloan'}>
                                          <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                                       </Link>
                                   </h1>
                                   <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                               </div>
                           </div>
                

                
                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage,  stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const rowFields = containerGroup[row].reduce((r, c) => {
                                            const DropdownValues = metaData[c.fieldDescription] && c.fieldValue && metaData[c.fieldDescription].find(_ => _.value === c.fieldValue) || false;
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        tableRow.push(rowFields);
                                        return tableRow;
                                    }, []) || [];
                                   
                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldType != "9" ? <Inputs
                                            field={Object.assign({}, {...field}, {disabled: field.fieldDescription === 'Installment Amount' ? true : field.disabled, dateFormat: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'month' : undefined})}
                                            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                            process={process}
                                            onInputChange={(e) => this.handleChange(e, field)}
                                            {...this.props}
                                            {...this.state} /> :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({[field.fieldName]: e.value})} style={{border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)'}}>
                                                    <div className="p-grid">
                                                        {containerFields.map((subField, subIndex) => <div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"}><Inputs
                                                            field={Object.assign({}, {...subField}, {disabled: subField.fieldDescription === 'Installment Amount' ? true : subField.disabled, dateFormat: (subField.fieldDescription === 'Repayment Start Month' || subField.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (subField.fieldDescription === 'Repayment Start Month' || subField.fieldDescription === 'Repayment End Month') ? 'month' : undefined})}
                                                            value={subField.fieldType === '3' && subField.fieldValue ? subField.fieldValue.split(",") : subField.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, subField)}
                                                            {...this.props}
                                                            {...this.state} /></div>
                                                        )}
                                                        <div className="p-col-12 p-md-6 p-lg-4">
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={() => this.setState({ editing: false })} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={() => this.setState({ editing: false })} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                    <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                                </div>}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                            expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                            rowExpansionTemplate={this.rowExpansionTemplate} 
                                                            dataKey="childRowNmbr" rows={10} value={containerTable}>
                                                            <Column expander={true} style={{ width: '3em' }} />
                                                                {containerFields.map((columnField, columnIndex) =>
                                                                    (pageType == 'edit' & columnField.fieldDescription == 'Original Currency') ? <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} body={this.currencyNameRender} /> : <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} /> 
                                                                    )}
                                                                {
                                                                    ((pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                }
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {/* {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VisitorPass'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null} */}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/materialpass-in'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger" label="Cancel" onClick={() => this.saveRequest('cancel')} />
                                        {/* <Button onClick={() => this.generatePayslip('view')} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* <Button /*disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.setState({ payslipDisplay: true})} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? <Button disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.generatePayslip('download')} className="p-button-success ml1" label="Download Loan Request as PDF" icon="pi pi-save" /> : null} */}
                                        {/* {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? */}
                                        {/* // <Button disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.generatePayslip('print')} className="p-button-success ml1" label="Print Loan Request" icon="pi pi-save" />: null} */}
                                        <Link to={'/EmployeeLoan'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>                                       
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }







}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    let countryList = state.master.Country || [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        currencyList: currencyList && currencyList || [],
        keywordValuesList,
        metaData: Object.assign({}, {
            "Requested For": relevantOptions,
            "Nationality": state.keyword.nationality,
            "Department ": state.keyword.OrgUnit,
            "Currency" : currencyList && currencyList || [],
            "Loan Type": state.keyword.LOANTYPE || [],
            "Deduction Frequency": state.keyword.salarytypen || []
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEmployeeLoan);